/**
 * Vuex module for licenses
 */
import debug from 'debug'
import API from '@/api'
import events from 'Store/events'

const dbg = debug('store:action:licenses:')

const actions = {
  get: function ({ commit }) {
    dbg('Get licenses')
    return API.getLicenses().then(response => {
      const data = response.data
      let videoConfLimit = 0
      data.forEach((license) => {
        if (license.feature === 'video_conf_limit') {
          videoConfLimit = parseInt(license.value)
        }
      })
      commit('VIDEO_CONF_LIMIT', videoConfLimit)
    }).catch(err => {
      dbg(err)
      const msg = API.getException(err) ||
                'Failed to get licenses from API.'
      events.pubError(msg)
    })
  }
}

const mutations = {
  VIDEO_CONF_LIMIT (state, videoConfLimit) {
    state.videoConfLimit = videoConfLimit
  }
}

const state = {
  videoConfLimit: 0 // 0: unlimited, -1: disabled
}

const getters = {
  videoConfLimit: state => state.videoConfLimit,
  videoConfEnabled: state => state.videoConfLimit !== -1
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
